import { BrandLogo, logoNames } from '@calendly/ui/components/brand-logo';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import Console from './logos/console.svg';
import Outlook from './logos/outlook.svg';
import OutlookExtension from './logos/outlook_extension.svg';
import Safari from './logos/safari.svg';
const logos = {
  console: Console,
  outlook: Outlook,
  outlookExtension: OutlookExtension,
  safari: Safari
};
const logoCss = "l1jtormt";
const Logo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(logoCss, props.className)} />;
});
const providerLogoSizeSmallCss = "p1w7lx7p";
const providerLogoSizeMediumCss = "py5p1t5";
const providerLogoSizeLargeCss = "p1wjokx4";
const providerLogoCss = "piwubp8";
export const ProviderLogo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    name,
    size = 'medium',
    alt = '',
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(providerLogoCss, {
    [providerLogoSizeSmallCss]: size?.toString() === 'small',
    [providerLogoSizeMediumCss]: size?.toString() === 'medium',
    [providerLogoSizeLargeCss]: size?.toString() === 'large'
  }, props.className)}>
      {logoNames.includes(name) ? <BrandLogo name={name} /> : <Logo src={logos[name]} alt={alt} />}
    </Component>;
});
ProviderLogo.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  as: PropTypes.elementType,
  alt: PropTypes.string,
  className: PropTypes.string
};
export { providerLogoCss };

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.js");